module.exports = __webpack_public_path__ + "media/images/admin/dropzone/move-8db6695c253ea5bc4a898e28fc6e5b11.svg";